<div *ngIf="!status" style="width: 100%; height: 100%; position: absolute; z-index: 1;"></div>
<div class="row">
  <h4>{{ data.display_name || data.name }}</h4>
  <div class="col-12">
    <app-switch-box [checked]="active" (switchStatus)="onChangeEndpoint($event)" [disabled]="!status">
    </app-switch-box>
  </div>
</div>